import { makeStyles } from '@material-ui/core/styles';
export default makeStyles((theme) => ({
  container: { width: '100%', padding: theme.spacing(0, 4, 4) },
  hint: { marginTop: theme.spacing(2), color: theme.colors.text_secondary }
}));
